import { registerTarget, defineSystemFields } from '@gat-ship/custom-fields'

/**
 * Side-effect registration of stakeholder targets and system fields.
 * Imported as `import './custom-field-definitions'` in this feature's index.ts
 * so it runs at module load time and populates the platform registry.
 *
 * See `platform/custom-fields/src/model/define-system-fields.ts` for how
 * the registration pattern works and how to add new entity targets.
 *
 * Field names must match the `name` prop on `<dyn-field>` wrappers
 * in the corresponding form components.
 */

registerTarget('Stakeholder.Client', {
  label: 'Client',
  group: 'Stakeholders'
})
registerTarget('Stakeholder.Vendor', {
  label: 'Vendor',
  group: 'Stakeholders'
})
registerTarget('Stakeholder.OtherParty', {
  label: 'Other Party',
  group: 'Stakeholders'
})

defineSystemFields('Stakeholder.Client', [
  {
    fieldName: 'name',
    label: 'Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'shortName',
    label: 'Short Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'countryCode',
    label: 'Country',
    fieldType: 'dropdown',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'email',
    label: 'Email',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'phoneNumber',
    label: 'Phone',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'clientNumber',
    label: 'Client Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'taxIdentificationNumber',
    label: 'Tax Identification Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'eoriNumber',
    label: 'EORI Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'postalAddress',
    label: 'Postal Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'visitAddress',
    label: 'Visit Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'invoiceEmail',
    label: 'Invoice Email',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  }
])

defineSystemFields('Stakeholder.Vendor', [
  {
    fieldName: 'name',
    label: 'Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'shortName',
    label: 'Short Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'countryCode',
    label: 'Country',
    fieldType: 'dropdown',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'email',
    label: 'Email',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'phoneNumber',
    label: 'Phone',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'vendorNumber',
    label: 'Vendor Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'taxIdentificationNumber',
    label: 'Tax Identification Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'eoriNumber',
    label: 'EORI Number',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'postalAddress',
    label: 'Postal Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'visitAddress',
    label: 'Visit Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  }
])

defineSystemFields('Stakeholder.OtherParty', [
  {
    fieldName: 'name',
    label: 'Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'shortName',
    label: 'Short Name',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'countryCode',
    label: 'Country',
    fieldType: 'dropdown',
    configurable: true,
    requiredByDeveloper: true
  },
  {
    fieldName: 'email',
    label: 'Email',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'phoneNumber',
    label: 'Phone',
    fieldType: 'text',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'postalAddress',
    label: 'Postal Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  },
  {
    fieldName: 'visitAddress',
    label: 'Visit Address',
    fieldType: 'multiline',
    configurable: true,
    requiredByDeveloper: false
  }
])
